import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import AthenaReports from '../components/AthenaReportsv2';
import { AntTabs, AntTab } from '../components/common/Tabs';
import PrintManagerDynamo from '../components/PrintManagerDynamo';

const tabs = {
  0: 'reports',
  1: 'print_manager',
  3: 'athena_reports',
  4: 'athena_print_manager',
};
const tabValues = {
  reports: 0,
  print_manager: 1,
  athena_reports: 3,
  athena_print_manager: 4,
};

const ReportsModule = ({ ...props }) => {
  const [tabVal, setTabVal] = useState(0);
  useEffect(() => {
    viewHash();

    const getHash = () => {};
    window.addEventListener('hashchange', getHash);
  }, [window.location.hash]);

  const viewHash = () => {
    setTabVal(
      window.location.hash ? tabValues[window.location.hash.slice(1)] : 0
    );
  };

  const handleTabChange = (event, newValue) => {
    setTabVal(newValue);
    window.location.hash = tabs[newValue];
  };

  return (
    <div style={{ padding: '0 0.5rem' }}>
      <Grid item xs={12} sm={12} md={12}>
        <AntTabs
          color={props.fetchInitialData.credentials.primaryAppColor}
          value={tabVal}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="ant example"
        >
    
            <AntTab
            color={props.fetchInitialData.credentials.primaryAppColor}
            label="Reports"
            value={0}
          />
          <AntTab
            color={props.fetchInitialData.credentials.primaryAppColor}
            label="Print Manager"
            value={1}
          />
    
       
        </AntTabs>
        <div style={{ position: 'relative', marginTop: '1.5rem' }}>
        {tabVal === 0 && <AthenaReports {...props} />}
          {tabVal === 1 && (
            <PrintManagerDynamo {...props}
            accessToken={props.fetchInitialData.credentials.user.accessToken} />
          )}
         

        </div>
      </Grid>
    </div>
  );
};

export default ReportsModule;
